export const isDiscountedProduct = (discount, cashback_amount) => {
  if (discount === '0' && !cashback_amount) {
    return {
      productType: 'Discount',
      discount: discount,
    };
  } else if (discount == '0' && cashback_amount > 0) {
    return {
      productType: 'Cashback',
      discount: cashback_amount,
    };
  } else if (discount == null && cashback_amount > 0) {
    return {
      productType: 'Cashback',
      discount: cashback_amount,
    };
  } else {
    return {
      productType: 'Discount',
      discount: discount,
    };
  }
};

export function sortByKey(data, key, order = 'asc') {
  if (!Array.isArray(data)) return null;

  return data.slice().sort((a, b) => {
    let valA = a[key];
    let valB = b[key];

    // Convert to Date if the key is likely a date string
    if (key.toLowerCase().includes('date') || key.includes('created_at')) {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    if (valA < valB) return order === 'asc' ? -1 : 1;
    if (valA > valB) return order === 'asc' ? 1 : -1;
    return 0;
  });
}

export function extractTitleAndDate(data) {
  if (!Array.isArray(data)) {
    throw new Error('Input must be an array');
  }

  return data.map(({ title, created_at }) => ({
    title,
    created_at,
  }));
}

export async function blogCategoryFilter(data, key, category) {
  if (!Array.isArray(data)) {
    return null;
  }

  if (!key || typeof key !== 'string') {
    throw new Error('A valid key must be provided');
  }

  if (typeof category === 'undefined' || category === null) {
    return data; // No filtering if category is not defined
  }

  return data.filter((item) => {
    // Make sure the key exists in the item
    if (!(key in item)) return false;

    // Compare by string match (case insensitive)
    return String(item[key]).toLowerCase() === String(category).toLowerCase();
  });
}

export const isValidInputAscii = (str) => {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const isLetter = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
    const isNumber = code >= 48 && code <= 57;
    const isHyphen = code === 45;

    if (!isLetter && !isNumber && !isHyphen) {
      return false;
    }
  }
  return true;
};

export const isValidInputAsciiWithSpace = (str) => {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);

    // ----- OLD rules (unchanged) -----
    const isLetter = (code >= 65 && code <= 90) || (code >= 97 && code <= 122); // A-Z, a-z
    const isNumber = code >= 48 && code <= 57; // 0-9
    const isHyphen = code === 45; // -
    const isSpace = code === 32; // space

    // ----- NEW rules (extra special symbols) -----
    const isSpecial = [
      38, // &
      95, // _
      43, // +
      46, // .
      44, // ,
      39, // '
      34, // "
      40, // (
      41, // )
      64, // @
      35, // #
      36, // $
      37, // %
      33, // !
      63, // ?
      47, // /
      92, // \
      58, // :
      59, // ;
      61, // =
      42, // *
      91, // [
      93, // ]
      123, // {
      125, // }
      60, // <
      62, // >
      124, // |
      126, // ~
      94, // ^
      96, // `
    ].includes(code);

    if (!isLetter && !isNumber && !isHyphen && !isSpace && !isSpecial) {
      return false;
    }
  }
  return true;
};

export const voucherBarCode = (voucherNo, voucherPin, voucherVal) => {
  if (voucherVal == true) {
    return voucherPin || null;
  }
  return voucherNo || null;
};

export const calculateNetPay = (items) => items.reduce((acc, item) => acc + item.TOTAL, 0);
export const totalDiscountCalculate = (total, dis) => (total / 100) * dis;

export const isUserSelectQty = (data) => {
  return data?.filter((item) => item?.QUANTITY > 0)?.length > 0 ? true : false;
};

export const getUniqueClass = (id, title) => {
  return `${title?.slice(0, 4)?.trim()?.toUpperCase()}-${id}`;
};

export function calculateDiscountedPrice(originalPrice, discount, isPercentage = true) {
  if (isPercentage) {
    return originalPrice * (1 - discount / 100);
  } else {
    return originalPrice - discount;
  }
}

export function capitalizeWord(str) {
  if (typeof str !== 'string' || str.length === 0) {
    return ''; // Handle empty or non-string input
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const safeParseJSON = (jsonString, defaultValue = null) => {
  // Check if input is already an object/array
  if (typeof jsonString !== 'string') {
    return jsonString;
  }

  // Check if string is empty or whitespace
  if (!jsonString || !jsonString.trim()) {
    return defaultValue;
  }

  try {
    const parsed = JSON.parse(jsonString);
    return parsed;
  } catch (error) {
    console.error('Failed to parse JSON:', error.message);
    return defaultValue;
  }
};

export const paymentChargesDeductionCalculation = (discount, charges) => {
  if (charges > 0) {
    return charges;
  } else {
    return 0;
  }
};

export const paymentModeDiscountCalculation = (discount, charges) => {
  const netDiscount = discount - charges;
  if (netDiscount > 0) {
    return netDiscount;
  } else {
    return 0;
  }
};

export const normalizeContent = (input) => {
  if (!input) return '';
  return input
    .replace(/<br\s*\/?>/gi, '\n') // Convert <br> to \n
    .replace(/\r\n|\r|\n/g, '\n'); // Normalize all newlines
};
